"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__ppt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7ddeecf7-d034-43ed-8775-c6f69c1612a9",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-ppt-hi"), /*#__PURE__*/React.createElement("g", {
    id: "79ca7019-bc2c-48dc-8bb8-efae7b0dd154",
    "data-name": "document-ppt-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0694c59e-fe07-4913-a2c2-dc38d83ed305",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ad531e55-263e-4196-8d63-4ea9b5d27c3a",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "72d33f6e-6cb3-499d-8fba-bb4be76b1c96",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "45ff3feb-a563-4ba7-9ce5-5b3cc664fbbb",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a05c8c60-28e6-46fa-b4a6-845c8835b4f9",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "84af9379-b2c6-481d-a02f-12e56fb12b70",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8f323fb0-9254-4cfa-b9a2-487bc92a5e86",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00d60dd2-dd53-459c-a263-5f4bd002fbfd",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "567e7600-90c8-4b9a-a244-fc3f36c22b64",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e935d84a-7ad0-452b-9acc-ce067f9d6255",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "768d1e2b-c535-4f2d-b661-8f970f4760d3",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "889df081-84fb-4758-99e4-966b936f0ac8",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d35a7d24-fddd-4f0a-8624-80a31ebb477f",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14de602f-1194-4a39-b2e8-9158a2963b2e",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4c0d8739-1fca-4200-83b5-5c4ef59e665d",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "62bc8bd5-b73c-480e-a6fe-fee7313f40e6",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0bd83d91-c1ea-4bfd-afd3-10ba2612d87d",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ff0991b9-377b-4ed4-93c1-94cfe34d62f7",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ded978c0-77ca-4e90-bb52-f54da1af149a",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3dbd6f3f-cef9-419e-a936-e72eff69613e",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1ab7d649-0163-4bdc-835c-0e9c401b91a8",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2a1c4a16-dfca-4104-910e-5549a7ff5ce6",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f576d6f9-a542-4189-98f8-f9547a1e69af",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "609d80df-9523-440d-8449-c4b0201faa36",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5f75cf4-a74c-4c99-b6ca-76c12af61530",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "91ea7b36-78df-4bd4-b98f-d2b5b99033dc",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a442c1fc-d9ab-48a7-973c-057e29c5f287",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e148f3c-6ed3-4375-a641-17eb39b155d8",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#7ddeecf7-d034-43ed-8775-c6f69c1612a9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,125.58a2.73,2.73,0,0,1-2.3-1,3.45,3.45,0,0,1-.77-2.17,3.52,3.52,0,0,1,.77-2.21,2.73,2.73,0,0,1,2.3-1,2.67,2.67,0,0,1,2.28,1,3.59,3.59,0,0,1,.75,2.21,3.52,3.52,0,0,1-.75,2.17A2.67,2.67,0,0,1,56.8,125.58Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,125.1V95.87h8.77a25,25,0,0,1,3.9.28,11.89,11.89,0,0,1,3.46,1.12,6.68,6.68,0,0,1,3.11,3.13,10.08,10.08,0,0,1,1,4.45,10.75,10.75,0,0,1-.75,4,8.72,8.72,0,0,1-1.86,3,7.74,7.74,0,0,1-2.3,1.64,13.44,13.44,0,0,1-3,.85,18.86,18.86,0,0,1-3,.24H70.12V125.1Zm5.52-15.56h3.11a16.45,16.45,0,0,0,2.17-.13,5.34,5.34,0,0,0,1.69-.48,3.61,3.61,0,0,0,1.71-1.58,4.67,4.67,0,0,0-.07-4.43A3.26,3.26,0,0,0,77,101.43a10.79,10.79,0,0,0-3.51-.53H70.12Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.66,125.1V95.87h8.77a25,25,0,0,1,3.9.28,11.89,11.89,0,0,1,3.46,1.12,6.68,6.68,0,0,1,3.11,3.13,10.08,10.08,0,0,1,1,4.45,10.75,10.75,0,0,1-.75,4,8.72,8.72,0,0,1-1.86,3,7.74,7.74,0,0,1-2.3,1.64,13.44,13.44,0,0,1-3,.85,18.86,18.86,0,0,1-3,.24H94.19V125.1Zm5.52-15.56H97.3a16.45,16.45,0,0,0,2.17-.13,5.34,5.34,0,0,0,1.69-.48,3.61,3.61,0,0,0,1.71-1.58,4.67,4.67,0,0,0-.07-4.43,3.26,3.26,0,0,0-1.78-1.49,10.79,10.79,0,0,0-3.51-.53H94.19Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,125.1V101.17h-8.28v-5.3h22.18v5.3h-8.28V125.1Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })))))))))))))))))))))))))))))));
}

var _default = ic_document__ppt;
exports.default = _default;